export default "__VITE_ASSET__CcFyCS9c__"